import { TemperatureInfo } from "../../temperature/temperature";

export const SubHeader = () => {
  return (
    <div className="h-6 absolute top-10 left-0 right-0 bg-gradient-to-bl from-blue-400 to-blue-600">
      <TemperatureInfo />
    </div>
  );
};
